import { render, staticRenderFns } from "./PerformancePhaseDialog.vue?vue&type=template&id=08a5ecec&scoped=true&"
import script from "./PerformancePhaseDialog.vue?vue&type=script&lang=js&"
export * from "./PerformancePhaseDialog.vue?vue&type=script&lang=js&"
import style0 from "./PerformancePhaseDialog.vue?vue&type=style&index=0&id=08a5ecec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a5ecec",
  null
  
)

export default component.exports